import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAlfaromeoComponent } from './simple-icons-alfaromeo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAlfaromeoComponent ],
    exports:      [ SimpleIconsAlfaromeoComponent ],
    bootstrap:    []
})
export class SimpleIconsAlfaromeoModule {}
